namespace Matrix.DataAudit {
    export interface FactAccountRow {
        Generation?: number;
        DateKey?: string;
        AccountCode?: string;
        AccountKey?: number;
        PendingAccountKey?: number;
        Status?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        AccountCodeName?: string;
        AccountCodeRowId?: number;
        AccountCodeAccountTypeCode?: string;
        AccountCodeAccountRoleCode?: string;
        AccountCodeManagerCode?: string;
        AccountCodeBaseCurrencyCode?: string;
        AccountCodeAssetClass?: string;
        AccountKeyAccountCode?: string;
        AccountKeyName?: string;
        AccountKeyGeneration?: number;
        AccountKeyIsCurrent?: string;
        AccountKeyCurrentFrom?: string;
        AccountKeyCurrentTo?: string;
        AccountKeyRowId?: number;
        AccountKeyStatus?: string;
        PendingAccountKeyAccountCode?: string;
        PendingAccountKeyName?: string;
        PendingAccountKeyGeneration?: number;
        PendingAccountKeyIsCurrent?: string;
        PendingAccountKeyCurrentFrom?: string;
        PendingAccountKeyCurrentTo?: string;
        PendingAccountKeyRowId?: number;
        PendingAccountKeyStatus?: string;
    }

    export namespace FactAccountRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'AccountCode';
        export const localTextPrefix = 'DataAudit.FactAccount';
        export const deletePermission = 'DataAdmin:AccountHistory';
        export const insertPermission = 'DataAdmin:AccountHistory';
        export const readPermission = 'Read:AccountHistory';
        export const updatePermission = 'DataAdmin:AccountHistory';

        export declare const enum Fields {
            Generation = "Generation",
            DateKey = "DateKey",
            AccountCode = "AccountCode",
            AccountKey = "AccountKey",
            PendingAccountKey = "PendingAccountKey",
            Status = "Status",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            AccountCodeName = "AccountCodeName",
            AccountCodeRowId = "AccountCodeRowId",
            AccountCodeAccountTypeCode = "AccountCodeAccountTypeCode",
            AccountCodeAccountRoleCode = "AccountCodeAccountRoleCode",
            AccountCodeManagerCode = "AccountCodeManagerCode",
            AccountCodeBaseCurrencyCode = "AccountCodeBaseCurrencyCode",
            AccountCodeAssetClass = "AccountCodeAssetClass",
            AccountKeyAccountCode = "AccountKeyAccountCode",
            AccountKeyName = "AccountKeyName",
            AccountKeyGeneration = "AccountKeyGeneration",
            AccountKeyIsCurrent = "AccountKeyIsCurrent",
            AccountKeyCurrentFrom = "AccountKeyCurrentFrom",
            AccountKeyCurrentTo = "AccountKeyCurrentTo",
            AccountKeyRowId = "AccountKeyRowId",
            AccountKeyStatus = "AccountKeyStatus",
            PendingAccountKeyAccountCode = "PendingAccountKeyAccountCode",
            PendingAccountKeyName = "PendingAccountKeyName",
            PendingAccountKeyGeneration = "PendingAccountKeyGeneration",
            PendingAccountKeyIsCurrent = "PendingAccountKeyIsCurrent",
            PendingAccountKeyCurrentFrom = "PendingAccountKeyCurrentFrom",
            PendingAccountKeyCurrentTo = "PendingAccountKeyCurrentTo",
            PendingAccountKeyRowId = "PendingAccountKeyRowId",
            PendingAccountKeyStatus = "PendingAccountKeyStatus"
        }
    }
}
